import { motion, useReducedMotion } from "motion/react";
import { Music, Music2, Music4 } from "lucide-react";

type Note = {
  Icon: typeof Music;
  left: string;
  bottom: string;
  size: number;
  duration: number;
  delay: number;
  drift: number;
  opacity: number;
};

const NOTES: Note[] = [
  { Icon: Music2, left: "8%", bottom: "12%", size: 26, duration: 10, delay: 0, drift: 18, opacity: 0.35 },
  { Icon: Music, left: "22%", bottom: "26%", size: 18, duration: 13, delay: 2.4, drift: -14, opacity: 0.28 },
  { Icon: Music4, left: "63%", bottom: "16%", size: 30, duration: 11, delay: 1.2, drift: 22, opacity: 0.32 },
  { Icon: Music2, left: "78%", bottom: "30%", size: 20, duration: 14, delay: 3.6, drift: -18, opacity: 0.26 },
  { Icon: Music, left: "88%", bottom: "10%", size: 24, duration: 12, delay: 0.8, drift: 16, opacity: 0.3 },
  { Icon: Music4, left: "46%", bottom: "8%", size: 16, duration: 15, delay: 4.2, drift: -12, opacity: 0.24 },
];

/**
 * Notes de musique flottant doucement vers le haut en arrière-plan du hero.
 * Purement décoratif : masqué et inactif si l'utilisateur préfère réduire le mouvement.
 */
export default function FloatingNotes() {
  const reduce = useReducedMotion();
  if (reduce) return null;

  return (
    <div
      className="absolute inset-0 z-[5] overflow-hidden pointer-events-none"
      aria-hidden="true"
    >
      {NOTES.map((n, i) => (
        <motion.span
          key={i}
          className="absolute text-white"
          style={{ left: n.left, bottom: n.bottom }}
          initial={{ opacity: 0, y: 30 }}
          animate={{
            y: [30, -160],
            x: [0, n.drift, 0],
            opacity: [0, n.opacity, n.opacity, 0],
            rotate: [0, n.drift > 0 ? 12 : -12, 0],
          }}
          transition={{
            duration: n.duration,
            delay: n.delay,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        >
          <n.Icon size={n.size} strokeWidth={1.6} />
        </motion.span>
      ))}
    </div>
  );
}
